import CookiesEuBanner from './cookies-eu-banner';

/**
 * Callback to load the cookies
 */
const loadCookies = () => {
    // GA handler defined on google_analytics.ctp
    if (typeof window.gcjoven_load_ga === 'function') {
        window.gcjoven_load_ga();
    }
};

/**
 * Cookies banner configuration
 * @param $
 */
const initCookies = ($) => {
    const cookiesBanner = new CookiesEuBanner(
        loadCookies, // callback to load cookies
        true // true: wait for user accept, false: auto close on delay
    );

    //if (cookiesBanner.hasConsent()) { window.gcjoven_load_ga(); }

    // Button to show banner again on click
    $('#cookies-eu-preferences').on('click', (e) => {
        e.preventDefault();

        cookiesBanner.showBanner();

        //cookiesBanner.deleteCookie(cookiesBanner.cookieName);
        //window.location.reload();

        return false;
    });
};

/**
 * Mobile menu collapse to show menu on hamburger button click/tap
 * @param $
 */
const mobileMenuCollapse = ($) => {
    function checkColapseMenu() {
        $('#main_menu').toggleClass('show', $(window).width() >= 1200);
    }
    checkColapseMenu();
    $(window).resize(checkColapseMenu);
};

/**
 * Scroll to top button
 * @param $
 */
const scrollToTop = ($) => {
    // Show/hide button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('.scrolltop:hidden').stop(true, true).fadeIn();
        } else {
            $('.scrolltop').stop(true, true).fadeOut();
        }
    });

    // Button click to return to top
    $(".scroll").click(() => {
        $("html,body").animate({scrollTop: $("body").offset().top}, "1000");
        return false
    })
};

/**
 * Initialize on page load
 */
[
    initCookies,
    mobileMenuCollapse,
    scrollToTop,
].forEach(fn => jQuery($ => fn($)));